import React, { lazy, useCallback } from 'react';

import { Period } from '@app/client';
import { fantasyAlphaGamesData } from '@app/pages/FantasyGames/alphaGamesData';
import { mapAlphaGameData, sortGamesBySubmissionEnd } from '@app/pages/FantasyGames/utils';
import { useFantasyGamesData } from '@app/pages/FantasyWishlist/hooks';
const GameCard = lazy(() =>
    import('@app/pages/FantasyGames/components').then((module) => ({ default: module.GameCard })),
);

type UseGamesContentProps = {
    period?: Period;
    onlyAlpha?: boolean;
};
export const useGamesContent = (props?: UseGamesContentProps) => {
    const { period, onlyAlpha } = props || {};
    const { competitions: pastGames, isLoading: pastLoading } = useFantasyGamesData(
        Period.Past,
        onlyAlpha || (period && period !== Period.Past),
    );
    const { competitions: presentGames, isLoading: activeLoading } = useFantasyGamesData(
        Period.Present,
        onlyAlpha || (period && period !== Period.Present),
    );
    const { competitions: futureGames, isLoading: futureLoading } = useFantasyGamesData(
        Period.Future,
        onlyAlpha || (period && period !== Period.Future),
    );

    //const activeGames = sortGamesBySubmissionEnd(presentGames) || [];
    const sortedPresentGames = sortGamesBySubmissionEnd(presentGames) || [];
    const sortedFutureGames = sortGamesBySubmissionEnd(futureGames) || [];
    const activeGames = [...new Set([...sortedPresentGames, ...sortedFutureGames])];
    const alphaData = fantasyAlphaGamesData.map(mapAlphaGameData);

    const gameCardMarkup = useCallback(
        (data, disableFadeIn?, isAlphaGame = false) =>
            data?.map((comp) => {
                if (comp) {
                    return (
                        <GameCard
                            key={`fantasy-home-${comp.id}-${comp.name}`}
                            competition={comp}
                            disableFadeIn={disableFadeIn}
                            isAlphaGame={isAlphaGame}
                        />
                    );
                }
            }) || [],
        [],
    );
    const liveContent = gameCardMarkup(activeGames, true);
    const pastContent = gameCardMarkup(pastGames);
    const alphaGamesContent = gameCardMarkup(alphaData, false, true);

    return {
        presentGames: activeGames,
        presentGamesLoading: activeLoading || futureLoading,
        activeGames,
        alphaGamesContent,
        liveContent,
        pastContent,
        activeLoading,
        pastLoading,
        //futureLoading,
    };
};
